import { faTimes } from '@fortawesome/pro-light-svg-icons'
import React, { FC } from 'react'

import dicLogo from '../../assets/img/logo-dipendenticloud-white.png'
import logoNewWhite from '../../assets/img/logo-new-white.png'
import logoNewWhite2x from '../../assets/img/logo-new-white@2x.png'
import logoNewWhite3x from '../../assets/img/logo-new-white@3x.png'
import { useAppSelector } from '../../redux/hooks'
import LanguageSwitcher from '../LanguageSwitcher'
import { HeaderProps } from './definitions'
import {
  HeaderContainer,
  IconClose,
  Logo,
} from './header.components'
import HeaderSearchSection from './SearchSection'

const HelpHeader: FC<HeaderProps> = (props: HeaderProps) => {
  const realm = useAppSelector((state) => state.realm.value)
  return (
    <HeaderContainer>
      <div className={'helpHeader'}>
        {!props.embedded && (
          <div className={'topHeader'}>
            {realm === 'fic' && (
              <Logo
                src={logoNewWhite}
                srcSet={logoNewWhite2x + ' 2x,' + logoNewWhite3x + ' 3x'}
                className={'logo'}
              />
            )}

            {realm === 'dic' && <Logo src={dicLogo} className={'logo'} />}
            {realm === 'dic-es' && <Logo src={dicLogo} className={'logo'} />}

            {realm === 'resellers' && (
              <>
                <Logo
                  src={logoNewWhite}
                  srcSet={logoNewWhite2x + ' 2x,' + logoNewWhite3x + ' 3x'}
                  className={'logo'}
                />
                <Logo
                  style={{ left: '170px' }}
                  src={dicLogo}
                  className={'logo'}
                />
              </>
            )}
            {process.env.REACT_APP_ENV != 'production' && <LanguageSwitcher />}
            {props.closeIcon && (
              <IconClose
                icon={faTimes}
                onClick={() => props.onClickClose()}
                size={'2x'}
                className={'closeIcon'}
              />
            )}
          </div>
        )}
        <HeaderSearchSection
          onChange={props.onChange}
          onSelect={props.onSelect}
          embedded={props.embedded}
        />
      </div>
    </HeaderContainer>
  )
}

export default HelpHeader
